import React, { Component } from "react";
import { connect } from "react-redux";

import { loadRubriques } from "../../store/actions/rubriqueAction";
import ListRevenusFonciers from "../../components/ListRevenusFonciers";

class RevenusFonciers extends Component {
  componentDidMount() {
    this.props.loadRubriques();
  }

  render() {
    const { rubriques } = this.props;

    return (
        <ListRevenusFonciers
          rubriques={rubriques}
        />
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadRubriques: () => dispatch(loadRubriques()),
  };
};

// mapper le state aux props du component
const mapStateToProps = (state) => {
  return {
    rubriques: state.rubriques.data,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RevenusFonciers);
